<div class="container" [ngStyle]="{'width': data.type ==='cycle' ? '850px' : '250px' }">
    <h2>Update {{data.title}}</h2>
    <div class="row">
        <mat-form-field *ngIf="data.type!=='user' && data.type !=='cycle' && data.type !=='cycleSettings'">
            <input type="text" matInput placeholder="{{data.title}} name" [(ngModel)]="data.name.name">
        </mat-form-field>
    </div>
   
    <!-- Company -->
    <div class="row">
        <mat-form-field *ngIf="data.type ==='company'">
            <input type="text" matInput placeholder="Contact name" [(ngModel)]="data.name.contactName">
        </mat-form-field>
    </div>
    <div class="row">
        <mat-form-field *ngIf="data.type ==='company'">
            <input type="text" matInput placeholder="Address" [(ngModel)]="data.name.address">
        </mat-form-field>
    </div>
    <div class="row">
        <mat-form-field *ngIf="data.type ==='company'">
            <input type="text" matInput placeholder="Email" [(ngModel)]="data.name.email">
        </mat-form-field>
    </div>
    <div class="row">
        <mat-form-field *ngIf="data.type ==='company'">
            <input type="text" matInput placeholder="Phone" [(ngModel)]="data.name.phone">
        </mat-form-field>
    </div>


   <!-- Cycle -->
   <div class="cols">
    <div class="col">
        <div class="row">
            <mat-form-field *ngIf="data.type ==='cycle'">
                <input type="text" matInput disabled placeholder="Cycle name" [(ngModel)]="data.name.name">
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field *ngIf="data.type ==='cycle'">
                <input type="text" matInput disabled placeholder="Strain name" [(ngModel)]="data.name.strainName">
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field *ngIf="data.type ==='cycle'">
                <mat-label>Current State</mat-label>
                <mat-select [(ngModel)]="data.name.currentState.state" (selectionChange)="fillterAlowd('zone')">
                    <mat-option *ngFor="let state of allowdStates" [value]="state">
                    {{state}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field *ngIf="data.type==='cycle' && data.name.currentState.state ==='Custom'">
                <input type="text" matInput placeholder="Custom State" [(ngModel)]="customState">
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field *ngIf="data.type==='cycle'">
                <mat-label>Pick zone</mat-label>
                <mat-select [(ngModel)]="data.name.zoneName._id" (selectionChange)="getParing($event.value)">
                    <mat-option *ngFor="let zone of allowdZones" [value]="zone._id" >
                        {{ zone.name }} ({{ zone.gatewayName }}) - {{zone.role}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>    
        <div class="row">
            <mat-form-field *ngIf="data.type==='cycle' && !harvestAndDryWeight && !harvest">
                <input type="number" matInput placeholder="Plants Quantity" [(ngModel)]="data.name.grow.plantsQuantity">
            </mat-form-field>
        </div>

        <div class="cycleTimes">
            <h2 *ngIf="data.type==='cycle'">Cycle Times</h2>
            <div class="row">
                <mat-form-field *ngIf="data.type==='cycle' || data.type==='cycleSettings'">
                    <input type="number" matInput placeholder="Mother time" [(ngModel)]="data.name.cycleTimes.motherTime">
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="smallField" *ngIf="data.type==='cycle' || data.type==='cycleSettings'">
                    <input type="number" matInput placeholder="Rooting time" [(ngModel)]="data.name.cycleTimes.rootingTime">
                </mat-form-field>
                <mat-form-field class="smallField" *ngIf="data.type==='cycle' || data.type==='cycleSettings'">
                    <input type="number" matInput placeholder="Veg time" [(ngModel)]="data.name.cycleTimes.vegTime">
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="smallField" *ngIf="data.type==='cycle' || data.type==='cycleSettings'">
                    <input type="number" matInput placeholder="Flowering time" [(ngModel)]="data.name.cycleTimes.floweringTime">
                </mat-form-field>
                <mat-form-field class="smallField" *ngIf="data.type==='cycle' || data.type==='cycleSettings'">
                    <input type="number" matInput placeholder="Flush time" [(ngModel)]="data.name.cycleTimes.flushingTime">
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="smallField" *ngIf="data.type==='cycle' || data.type==='cycleSettings'">
                    <input type="number" matInput placeholder="Drying time" [(ngModel)]="data.name.cycleTimes.dryingTime">
                </mat-form-field>
                <mat-form-field class="smallField" *ngIf="data.type==='cycle' || data.type==='cycleSettings'">
                    <input type="number" matInput placeholder="Curing time" [(ngModel)]="data.name.cycleTimes.curingTime">
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="smallField" *ngIf="data.type==='cycle' || data.type==='cycleSettings'">
                    <input type="number" matInput placeholder="Pack time" [(ngModel)]="data.name.cycleTimes.packTime">
                </mat-form-field>
                <mat-form-field class="smallField" *ngIf="data.type==='cycle' || data.type==='cycleSettings'">
                    <input type="number" matInput placeholder="Safe time" [(ngModel)]="data.name.cycleTimes.safeTime">
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="col">
        <section *ngIf="data.type==='cycle' && paring.subtasks.length">
            <!-- <mat-label>Paring Sensors and Appliances</mat-label> -->
            <span class="example-list-section">
                <mat-checkbox [(ngModel)]="data.paring"
                [checked]="selectAll"
                [color]="paring.color"
                [indeterminate]="someComplete()"
                (change)="setAll($event.checked)">
                    {{paring.name}}
                </mat-checkbox>
            </span>
            <span class="example-list-section">
                <ul>
                  <li *ngFor="let subtask of paring.subtasks">
                    <mat-checkbox [(ngModel)]="subtask.completed"
                                  [color]="subtask.color"
                                  (ngModelChange)="updateAllComplete()">
                      {{subtask.name}} ({{subtask.kind}})
                    </mat-checkbox>
                  </li>
                </ul>
              </span>
        </section>
    </div>
    <div class="col" *ngIf="harvestAndDryWeight">
        <div class="row">
            <mat-form-field *ngIf="data.type==='cycle'">
                <input type="number" matInput placeholder="Total Plants" [disabled]="disabledPlantsQuantity" [(ngModel)]="data.name.grow.plantsQuantity">
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field *ngIf="data.type==='cycle'">
                <input type="number" matInput placeholder="Total Harvest" [disabled]="disabledHarvestQuantity" [(ngModel)]="data.name.grow.harvestQuantity">
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field *ngIf="data.type==='cycle'">
                <input type="number" matInput placeholder="Wet Weight" [(ngModel)]="data.name.harvest.wetWeight">
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field *ngIf="data.type==='cycle' && !disabledDryWeight">
                <input type="number" matInput placeholder="Dry Weight" [(ngModel)]="data.name.harvest.dryWeight">
            </mat-form-field>
        </div>

        <!-- Harvest -->
        <div class="rightLeft" *ngIf="data.type ==='cycle'  && (harvest || DryWeight)">
            <div class="cols">
                <div class="col">
                    <h2 *ngIf="data.type==='cycle' && harvest" class="harvest">Harvest</h2>
                    <div class="row">
                        <mat-form-field *ngIf="data.type==='cycle' && !disabledHarvest && harvest">
                            <mat-label>Pick zone</mat-label>
                            <mat-select [(ngModel)]="data.name.dryingZone" (selectionChange)="disabledUpdateHarvestButton($event.value)">
                                <mat-option *ngFor="let zone of allowdDryingZones" [value]="zone._id" >
                                    {{ zone.name }} ({{ zone.gatewayName }}) - {{zone.role}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
            
                    <div class="row">
                        <mat-radio-group *ngIf="data.type==='cycle' && harvest" [(ngModel)]="data.name.harvest.quantity">
                            <div>
                                <mat-radio-button class="harvestQuantity" value="all" (click)="customPlants('all')">All batch</mat-radio-button>
                            </div>
                            <div>
                                <mat-radio-button class="harvestQuantity" value="half" (click)="customPlants('half')">Half batch</mat-radio-button>
                            </div>
                            <div>
                                <mat-radio-button class="harvestQuantity" value="custom" (click)="customPlants('custom')">Custom</mat-radio-button>
                            </div>
                          </mat-radio-group>
                    </div>
                    <div class="row">
                        <mat-form-field *ngIf="data.type==='cycle' && harvest" class="PlantsToHarvest">
                            <input type="number" [disabled]="disabledPlantsToHarvest" matInput placeholder="Plants to Harvest" [(ngModel)]="data.name.harvest.PlantsToHarvest" (change)="disabledUpdateHarvestButton(null)">
                        </mat-form-field>
                    </div>
                    <div class="row">
                        <mat-form-field *ngIf="data.type==='cycle' && harvest">
                            <input type="number" matInput placeholder="Wet Weight" [(ngModel)]="data.name.harvest.updateWetWeight" (change)="disabledUpdateHarvestButton(null)">
                        </mat-form-field>
                    </div>
                    <button *ngIf="data.type==='cycle' && harvest" mat-flat-button color="primary" class="UpdateButton" (click)="updateHarvest()">Update</button>
                <!-- Update Dry Weight -->
            
                    <div class="row">
                        <h2 *ngIf="data.type==='cycle' && DryWeight" class="DryWeight">Dry Weight</h2>
                    </div>
                    <div class="row">
                        <mat-form-field *ngIf="data.type==='cycle' && DryWeight">
                            <input type="number" matInput placeholder="Dry Weight" [(ngModel)]="data.name.harvest.updateDryWeight" (change)="disabledUpdateDryWeightButton()">
                        </mat-form-field>
                    </div>
                    <button *ngIf="data.type==='cycle' && DryWeight" mat-flat-button color="primary" class="UpdateButton" (click)="updateDryWeight()">Update</button>
                </div>        
            
                <div class="col">
                    <section *ngIf="data.type==='cycle' && paringDry.subtasks.length && harvest" class="paringDry">
                        <!-- <mat-label>Paring Sensors and Appliances</mat-label> -->
                        <span class="example-list-section">
                            <mat-checkbox [(ngModel)]="data.paringDry"
                            [checked]="selectAllDry"
                            [color]="paringDry.color"
                            [indeterminate]="someComplete()"
                            (change)="setAllDry($event.checked)">
                                {{paringDry.name}}
                            </mat-checkbox>
                        </span>
                        <span class="example-list-section">
                            <ul>
                              <li *ngFor="let subtask of paringDry.subtasks">
                                <mat-checkbox [(ngModel)]="subtask.completed"
                                              [color]="subtask.color"
                                              (ngModelChange)="updateAllComplete()">
                                  {{subtask.name}} ({{subtask.kind}})
                                </mat-checkbox>
                              </li>
                            </ul>
                          </span>
                    </section>
                </div>
            </div>
        </div>
        </div>
   </div>
    
    
    <mat-form-field *ngIf="data.type==='gateway' || data.type==='sensor'">
        <input type="text" matInput placeholder="Hardware ID" [(ngModel)]="data.name.hardwareId">
    </mat-form-field>
    <mat-form-field *ngIf="data.type==='sensor'">
        <mat-label>Sensor kind</mat-label>
        <mat-select [(ngModel)]="data.name.kind">
            <mat-option *ngFor="let sk of items['sensorKinds']" [value]="sk">
                {{ sk }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <!-- Zone -->
    <mat-form-field *ngIf="data.type!=='user' && data.type==='zone'">
    <mat-label>Pick gateway</mat-label>
    <mat-select [(ngModel)]="data.name.gateway">
        <mat-option *ngFor="let item of items[data.type]" [value]="item._id">
        {{item.name}} ({{item.hardwareId}})
        </mat-option>
    </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="data.type==='zone'">
        <mat-label>Zone role</mat-label>
        <mat-select [(ngModel)]="data.name.role">
            <mat-option *ngFor="let item of zoneRole" [value]="item">
            {{item}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="data.type==='zone'">
        <input type="number" matInput placeholder="Zone size" [(ngModel)]="data.name.size">
    </mat-form-field>

    <mat-form-field *ngIf="data.type==='sensor'">
        <mat-label>Pick zone</mat-label>
        <mat-select [(ngModel)]="data.name.zone">
            <mat-option *ngFor="let zone of items['zone']" [value]="zone._id">
                {{ zone.name }} ({{ zone.gatewayName }})
            </mat-option>
        </mat-select>
    </mat-form-field>

    <!-- User -->
    <mat-form-field *ngIf="data.type==='user'">
        <input type="text" [disabled]="true" matInput placeholder="Email" [(ngModel)]="data.data.email">
    </mat-form-field>
    <!-- <mat-form-field *ngIf="data.type==='user'">
        <input type="text" matInput placeholder="Password" [(ngModel)]="data..data.password">
    </mat-form-field> -->
    <mat-form-field *ngIf="data.type==='user'">
        <input type="text" matInput placeholder="Name" [(ngModel)]="data.data.name">
    </mat-form-field>
    <mat-form-field *ngIf="data.type==='user'">
        <input type="text" matInput placeholder="Phone" [(ngModel)]="data.data.phone">
    </mat-form-field>
    <mat-form-field *ngIf="data.type==='user' && data.company!=undefined">
        <mat-label>Role</mat-label>
        <mat-select [(ngModel)]="data.data.role">
            <mat-option value="r">Read Only</mat-option>
            <mat-option value="rw">Read / Write</mat-option>
        </mat-select>
    </mat-form-field>    
    <section class="example-section" *ngIf="data.type==='user'">
        <mat-checkbox class="example-margin" color="primary" [(ngModel)]="data.data.notificationsEnabled">Enabled notifications</mat-checkbox>
    </section>

    <section class="example-section" *ngIf="data.type==='user' && data.data.notificationsEnabled">
        <mat-checkbox class="notificationOptions" color="primary" [(ngModel)]="data.data.notificationsEnabledEmail">Email</mat-checkbox>
        <mat-checkbox class="notificationOptions" color="primary" [(ngModel)]="data.data.notificationsEnabledSms">SMS</mat-checkbox>
        <mat-checkbox class="notificationOptions" color="primary" [(ngModel)]="data.data.notificationsEnabledPush">Push</mat-checkbox>
    </section>

    <mat-dialog-actions align="end">
        <button mat-button [mat-dialog-close]="undefined">Cancel</button>
        <button mat-flat-button color="primary" (click)="onConfirm()">Save</button>
    </mat-dialog-actions>
    <div class="loading-wrapper" *ngIf="isLoading">
        <mat-spinner diameter="30"></mat-spinner>
    </div>
</div>